import {Client} from '../../../shared/utilities/type-helpers';
import {environment as env} from './environment.live';
const client: Client = {clientType: 'claro'};

export const environment = {
  ...env,
  // For Firebase JS SDK v7.20.0 and later, measurementId is optional
  firebaseConfig: {
    apiKey: 'AIzaSyAjquVi57pBfC6oPWabXZHM7rxFN66YtT4',
    authDomain: 'claro-live.firebaseapp.com',
    databaseURL: 'https://claro-live-default-rtdb.firebaseio.com',
    projectId: 'claro-live',
    storageBucket: 'claro-live.appspot.com',
    messagingSenderId: '461674849085',
    appId: '1:461674849085:web:2c560ab3bf4a7a311cdb54',
    measurementId: 'G-PJMB9H33ZC',
  },
  client,
  dockerCompose: false,
};
